/* eslint-disable jsx-a11y/alt-text */
import red from '../../images/red.svg';

export const RedCard = () => (
  <img src={red} width={14} height={14} />
)
